import React from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';
import BlueBookButton from 'chameleon/packages/blue-book-player/library/bluebook-button/BlueBookButton';

const Tab = ({
  tabId,
  isSelected,
  onClick,
  accessibility,
  className,
  selectedClassName,
  children,
}) => {
  const onTabClick = () => {
    onClick(tabId);
  };

  return (
    <BlueBookButton
      id={tabId}
      className={cn('rounded-none', className, {
        [selectedClassName]: isSelected,
      })}
      role="tab"
      aria-selected={isSelected}
      onClick={onTabClick}
      {...accessibility}
    >
      {children}
    </BlueBookButton>
  );
};

Tab.propTypes = {
  tabId: PropTypes.string.isRequired,
  isSelected: PropTypes.bool.isRequired,
  onClick: PropTypes.func.isRequired,
  accessibility: PropTypes.object.isRequired,
  className: PropTypes.string,
  selectedClassName: PropTypes.string,
};

Tab.defaultProps = {
  className: null,
  selectedClassName: null,
};

export default Tab;
